// extracted by mini-css-extract-plugin
export default {"stepper":"Stepper_stepper__rq9Ac","stepper__item":"Stepper_stepper__item__0pJfB","stepper__icon":"Stepper_stepper__icon__5E4Q8","stepper__divider":"Stepper_stepper__divider__Wxe2o"};